enum NoteRoutes {
  List = '/notes',
  Edit = '/notes/edit/:display_name/:id',
  Add = '/notes/add/:note_type/:display_name/:parent_id',
}

export default NoteRoutes
